import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../music24/components/primitives/SMLButton';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the sheet; each part uses its own slice of it */
import styles from './SMLCreationSheet.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CreationSheetFooterProps {
  /** One sentence saying what pressing the button does. */
  note: string;
  /** Left out on the first stage, where there is nowhere back to. */
  onBack?: () => void;
  onCancel?: () => void;
  primaryLabel?: string;
  primaryDisabled?: boolean;
  onPrimary?: () => void;
  /** A second, quieter action — "Create anyway" on the duplicate guard. */
  secondaryLabel?: string;
  onSecondary?: () => void;
}

/**
 * What happens next, in a sentence, next to the one button that does it.
 *
 * The old wizard's footer said "1/2 Upload link", which named a step rather
 * than a consequence.
 */
const CreationSheetFooterComponent: React.FC<CreationSheetFooterProps> = ({
  note,
  onBack,
  onCancel,
  primaryLabel,
  primaryDisabled,
  onPrimary,
  secondaryLabel,
  onSecondary,
}) => {
  const intl = useIntl();

  return (
    <div className={styles.foot}>
      <p className={styles.footNote}>{note}</p>
      {onBack !== undefined && (
        <SMLButton onClick={onBack}>
          {intl.formatMessage({ id: 'app.sml.create.back', defaultMessage: 'Back' })}
        </SMLButton>
      )}
      {onCancel !== undefined && (
        <SMLButton onClick={onCancel}>
          {intl.formatMessage({ id: 'app.sml.create.cancel', defaultMessage: 'Cancel' })}
        </SMLButton>
      )}
      {secondaryLabel !== undefined && onSecondary !== undefined && (
        <SMLButton onClick={onSecondary}>{secondaryLabel}</SMLButton>
      )}
      {primaryLabel !== undefined && onPrimary !== undefined && (
        <SMLButton variant="primary" disabled={primaryDisabled} onClick={onPrimary}>
          {primaryLabel}
        </SMLButton>
      )}
    </div>
  );
};

export const CreationSheetFooter = TypedMemo(CreationSheetFooterComponent);
